import styled from "styled-components";

export const ProgressContainer = styled.div`
    text-align: center;
    .upload-progress .ant-progress-text {
        color: white;
    }

    .upload-progress .ant-progress-inner,
    .upload-progress svg.ant-progress-circle {
        width: 33px !important;
        height: 33px !important;
        font-size: 9px !important;
    }
`;
